import { useEventListener, useIntervalFn, useThrottleFn } from "@vueuse/core"

export const IDLE_MS = 20 * 60 * 1000
const CHECK_MS = 10 * 1000
const KEY = "last_activity"
const EVENTS = ["mousemove", "mousedown", "keydown", "touchstart", "wheel", "scroll"]

/**
 * Has the session been idle long enough to be dropped?
 * Re-arms the clock when the stamp is missing, so a fresh login right after
 * localStorage.clear() is not logged out on the very first tick.
 *
 * Exported for useAutoLogout.check.mjs.
 *
 * @param {number} now - current timestamp
 * @returns {boolean}
 */
export function isSessionIdle(now = Date.now()) {
  if (!localStorage.getItem("access_token"))
    return false
  const last = Number(localStorage.getItem(KEY))
  if (!last) {
    localStorage.setItem(KEY, now)
    return false
  }
  return now - last >= IDLE_MS
}

/**
 * Logs the user out after IDLE_MS without any interaction.
 * The timestamp lives in localStorage, so every open tab shares one idle
 * clock — a background tab cannot log out a user working in another tab.
 *
 * @param {Function} logout - called once the session went idle (Vue's $logout)
 */
export default function useAutoLogout(logout) {
  // ponytail: throttled — a raw mousemove listener would hit localStorage ~60x/s
  const touch = useThrottleFn(() => localStorage.setItem(KEY, Date.now()), 5000)
  EVENTS.forEach(e => useEventListener(window, e, touch, { passive: true }))
  localStorage.setItem(KEY, Date.now())

  useIntervalFn(() => {
    if (isSessionIdle())
      logout()
  }, CHECK_MS)
}
